// extracted by mini-css-extract-plugin
module.exports = {"popup":"Map_popup__bUlWh","dark":"Map_dark__cPVuz"};